import { delegateInfobarMessage } from './createDelegateInfoBarMessage.locstring.json';
import loc, { format } from 'owa-localize';
import MeetingMessage from 'owa-service/lib/contract/MeetingMessage';

import isMeetingMessage from 'owa-meeting-message/lib/utils/isMeetingMessage';

/**
 * Returns all the infobar messages to show in the infobar
 */
export default function getDelegateInfoBarMessages(message: MeetingMessage): string[] {
    if (isMeetingMessage(message) && message.IsDelegated && message.ReceivedRepresenting != null) {
        return [format(loc(delegateInfobarMessage), message.ReceivedRepresenting.Mailbox.Name)];
    } else {
        return [];
    }
}
